<template>
    <span>
        <button class="nav-item dropdown-item btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <!-- added close directive in order to reset the modal state -->
        <modal :show.sync="modals.classic" @close="resetModal" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Organizational Report</h4>
            <hr />
            <div class="container">
                <label>Organizations:</label>
                
                <treeselect
                    v-model="organizationId"
                    class="select-primary"
                    name="organization"
                    v-validate="'required'"
                    data-vv-as="Organization"
                    :multiple="false"
                    :clearable="true"
                    :searchable="true"
                    :open-on-click="true"
                    :open-on-focus="false"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :always-open="false"
                    :append-to-body="false"
                    search-nested
                    :options="jointStaffOrganizations"
                />
             <span v-show="errors.has('organization')" class="error"
              > {{ errors.first("organization") }}
            </span>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                   
                    <base-button 
                    
                        type="danger" 
                        class="alert_footer_button btn_extra_small btn_info mr-4" 
                        @click.native="resetModal();"
                    >
                        Close
                    </base-button>
                     <base-button 
                        type="primary"
                        class="alert_footer_button btn_extra_small btn_info "
                        @click.native="submit"
                    >
                        Submit
                    </base-button>
                  
                </div>
            </template>
        </modal>
    </span>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { BaseButton, Modal } from "@/components";
    import axios from "@/axios";
    import Utility from "@/mixins/utility/utility";
    import swal from "sweetalert2";
    import Util from "@/util/util";
    import Treeselect from "@riophae/vue-treeselect";
    //import "@riophae/vue-treeselect/dist/vue-treeselect.css";

    export default {
        name: "organizational-report-modal",
         components: {
            Modal,
            BaseButton,
            Treeselect
        },
        mixins: [Utility],
        props: {
        },
        data() {
            return {
                organizationId: null,
                modals: {
                    classic: false,
                },
            };
        },
        computed: {
            ...mapGetters({
                jointStaffOrganizations: "organization/jointStaffOrganizations",
            }),
        },
        methods: {
            ...mapActions({
                getJointStaffOrganizations: "organization/getJointStaffOrganizations",
            }),
            viewItem() {
                let ctx = this;
                
                ctx.getJointStaffOrganizations().then(() => {
                    ctx.modals.classic = true;
                });
            },
            async submit(e) {
                this.excelLoadTime += 1; // Start tracking the loading state
                let ctx = this;
                let elapsedTime = 0; // Variable to track the total elapsed time

                // Timer logic with a 2-second delay for the first message
                let initialMessageShown = false;
                //console.log("Starting 2-second delay...");
                await new Promise((resolve) => setTimeout(resolve, 2000)); // 2-second delay
                elapsedTime += 2000; // Add the delay to the elapsed time
                //console.log("2-second delay completed.");
                if (this.excelLoadTime !== 0 && !initialMessageShown) {
                    this.showLoadingSweetAlert(
                        "Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds."
                    );
                    initialMessageShown = true; // Ensure the first message is marked as shown
                   // console.log("Initial loading message shown.");
                }

                const intervalId = setInterval(() => {
                    if (this.excelLoadTime === 0) {
                        clearInterval(intervalId); // Stop the interval when the process is complete
                        //console.log(`Total elapsed time: ${elapsedTime / 1000} seconds`); // Log the total elapsed time
                    } else {
                        //console.log("Showing periodic loading message...");
                        this.showLoadingSweetAlert(
                            "Please hang tight.  Your Excel document is <i>still loading</i>.<br><br><b>Note: <br><li>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.</li>"
                        );
                    }
                    elapsedTime += 10000; // Increment elapsed time by 10 seconds for each interval
                }, 10000); // Check every 10 seconds

                try {
                    // Validate the form
                    const result = await this.$validator.validateAll();
                    if (result) {
                        // Start the report generation
                        await ctx.generateReport(`/api/acsareports/organizational/${ctx.organizationId}`, `Organizational_Report.xlsx`);
                    }
                } catch (error) {
                    this.showErrorAlert("An error occurred while generating the report. Please try again.");
                } finally {
                    // Ensure the loading state is reset after the process completes
                    setTimeout(() => {
                        this.excelLoadTime = 0;
                    }, 1000); // Small delay to ensure all messages are displayed before resetting
                }
            },
            showLoadingSweetAlert(message) {
                // Skip this alert if no organization selected
                if (!this.organizationId) {
                    return;
                }
                new swal({
                    position: 'top-end',
                    icon: 'info',
                    title: 'Please Wait Patiently',
                    html: message,
                    timer: 10000,
                    showConfirmButton: false
                });
            },
            // resets the modal state
            resetModal() {
                this.organizationId = null;
                this.errors.clear(); // clears all validation errors
                this.$validator.reset(); // reset the validator
                this.modals = this.modals || {}; 
                this.modals.classic = false;
            },
            generateReport(url, title) {
                let ctx = this;
                return axios({
                    url: url,
                    method: "GET",
                    responseType: "blob", 
                })
                    .then((response) => {
                        Util.fileDownload(response.data, title); // Trigger the file download
                        ctx.excelLoadTime = 0; // Mark the download as complete
                    })
                    .catch((error) => {
                        console.error("Error downloading file:", error);
                        ctx.excelLoadTime = 0; // Reset the loading state on error
                        throw error; // Propagate the error
                    });
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
        },
    };
</script>
